import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { FaPaperPlane } from "react-icons/fa";

const API = `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001'}/api`;

const EnquiryDialog = ({ open, onOpenChange, productName }) => {
    const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
    const [loading, setLoading] = useState(false);

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.phone) {
            toast.error("Please add your name and phone.");
            return;
        }
        setLoading(true);
        try {
            await axios.post(`${API}/enquiry`, { product_name: productName, ...form });
            toast.success("Enquiry submitted! We'll contact you soon.");
            setForm({ name: "", phone: "", email: "", message: "" });
            onOpenChange(false);
        } catch (err) {
            toast.error("Could not submit. Try WhatsApp or call us.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-testid="enquiry-dialog" className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle className="font-heading">Enquire about</DialogTitle>
                    <DialogDescription>{productName || "this product"}</DialogDescription>
                </DialogHeader>
                <form onSubmit={submit} className="space-y-3">
                    <Input data-testid="enquiry-input-name" placeholder="Your name *" value={form.name} onChange={set("name")} />
                    <Input data-testid="enquiry-input-phone" placeholder="Phone *" value={form.phone} onChange={set("phone")} />
                    <Input data-testid="enquiry-input-email" type="email" placeholder="Email" value={form.email} onChange={set("email")} />
                    <Textarea data-testid="enquiry-input-message" rows={3} placeholder="Message" value={form.message} onChange={set("message")} />
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="enquiry-submit-btn"
                        className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-gradient-to-r from-brand-700 to-brand-500 text-white font-semibold disabled:opacity-60 transition"
                    >
                        {loading ? "Sending..." : <>Send Enquiry <FaPaperPlane /></>}
                    </button>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default EnquiryDialog;
